'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _colors = require('HubStyleTokens/colors');

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _UIImage = require('../image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _UIIconCircle = require('../icon/UIIconCircle');

var _UIIconCircle2 = _interopRequireDefault(_UIIconCircle);

var _iconName = require('../utils/propTypes/iconName');

var _deprecated = require('../utils/propTypes/deprecated');

var _deprecated2 = _interopRequireDefault(_deprecated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// objectTypes
var COMPANY = 'COMPANY';
var CONTACT = 'CONTACT';

// Build number in DEFAULT_BASE is arbitrary, but there for a reason. See:
// HubSpot/SalesUIComponents#79.
var DEFAULT_BASE = 'https://static.hsappstatic.net/salesImages/static-1.291/avatars';
var DEFAULT_COMPANY = DEFAULT_BASE + '/default-company-avatar.png';
var DEFAULT_CONTACT = DEFAULT_BASE + '/default-avatar.png';

var SIZE_CLASSES = {
  responsive: '',
  'extra-small': 'private-avatar--xs',
  small: 'uiAvatarSmall private-avatar--sm',
  medium: 'uiAvatarMedium private-avatar--md',
  large: 'uiAvatarLarge private-avatar--lg',
  'extra-large': 'uiAvatarXLarge private-avatar--xl'
};

var BADGE_ICON_SIZES = {
  small: 7,
  medium: 12,
  large: 14,
  'extra-large': 18
};

var IMAGE_SHAPES = ['default', 'circle', 'square', 'rounded', 'thumbnail'];

function getDefaultPortalId() {
  /* eslint-disable hubspot-is-special */
  if (!window.hubspot) {
    return undefined;
  }
  var _window = window,
      hubspot = _window.hubspot;

  if (hubspot.PortalIdParser && typeof hubspot.PortalIdParser.get === 'function') {
    return hubspot.PortalIdParser.get();
  }
  return hubspot.portal && hubspot.portal.id;
  /* eslint-enable hubspot-is-special */
}

var defaultProps = {
  fetchAvatars: function fetchAvatars() {},
  portalId: getDefaultPortalId(),
  size: 'responsive',
  imageShape: 'circle',
  objectType: CONTACT,
  iconColor: _colors.OLAF,
  iconBackgroundColor: _colors.CALYPSO
};

var createWarningMessage = function createWarningMessage(propName) {
  return {
    message: 'UIAvatar: the ' + propName + ' prop has been deprecated. Please use ui-addon-avatars instead.',
    key: 'UIAvatar: deprecated ' + propName + ' prop',
    url: 'https://tools.hubteamqa.com/ui-library/addons/ui-addon-avatars'
  };
};

var UIAvatar = _react2.default.createClass({
  displayName: 'UIAvatar',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    className: _react.PropTypes.string,
    defaultImage: (0, _deprecated2.default)(_react.PropTypes.string, createWarningMessage),
    domain: (0, _deprecated2.default)(_react.PropTypes.string, createWarningMessage),
    email: (0, _deprecated2.default)(_react.PropTypes.string, createWarningMessage),
    fetchAvatars: (0, _deprecated2.default)(_react.PropTypes.func, createWarningMessage, defaultProps.fetchAvatars),
    iconBackgroundColor: _react.PropTypes.string,
    iconColor: _react.PropTypes.string,
    iconName: (0, _iconName.getIconNamePropType)(),
    imageShape: _react.PropTypes.oneOf(IMAGE_SHAPES),
    objectType: (0, _deprecated2.default)(_react.PropTypes.oneOf([COMPANY, CONTACT]), createWarningMessage, defaultProps.objectType),
    onClick: _react.PropTypes.func,
    portalId: (0, _deprecated2.default)(_react.PropTypes.number, createWarningMessage, defaultProps.portalId),
    size: _react.PropTypes.oneOf(Object.keys(SIZE_CLASSES)),
    source: (0, _deprecated2.default)(_react.PropTypes.string, createWarningMessage),
    src: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return defaultProps;
  },
  getClassName: function getClassName(classNameProps) {
    var className = classNameProps.className,
        iconName = classNameProps.iconName,
        size = classNameProps.size;

    return (0, _classNames2.default)('private-avatar', SIZE_CLASSES[size], className, {
      'private-with-icon': Boolean(iconName)
    });
  },
  getDefaultImage: function getDefaultImage(_ref) {
    var defaultImage = _ref.defaultImage,
        domain = _ref.domain,
        objectType = _ref.objectType;

    if (defaultImage) {
      return defaultImage;
    } else if (objectType === COMPANY || domain) {
      return DEFAULT_COMPANY;
    }
    return DEFAULT_CONTACT;
  },
  renderImage: function renderImage(_ref2, _ref3) {
    var imageShape = _ref2.imageShape,
        size = _ref2.size,
        rest = _objectWithoutProperties(_ref2, ['imageShape', 'size']);

    var computedSrc = _ref3.computedSrc;

    var computedImageShape = imageShape;

    if (imageShape === 'default') {
      _devLogger2.default.warn({
        message: 'UIAvatar: `imageShape` value of `default` has been deprecated, please use `square` instead',
        key: 'UIAvatar: deprecated imageShape default prop'
      });
    }

    if (imageShape === 'square') {
      computedImageShape = 'default';
    }

    return _react2.default.createElement(_UIImage2.default, _extends({}, rest, {
      responsive: size === 'responsive',
      shape: computedImageShape,
      src: computedSrc
    }));
  },
  renderIcon: function renderIcon(_ref4) {
    var iconBackgroundColor = _ref4.iconBackgroundColor,
        iconColor = _ref4.iconColor,
        iconName = _ref4.iconName,
        size = _ref4.size;

    var computedSize = BADGE_ICON_SIZES[size];
    if (!iconName || !computedSize) {
      return null;
    }
    return _react2.default.createElement(_UIIconCircle2.default, {
      backgroundColor: iconBackgroundColor,
      color: iconColor,
      className: 'badge-icon',
      name: iconName,
      size: computedSize,
      legacy: true
    });
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        defaultImage = _props.defaultImage,
        domain = _props.domain,
        __email = _props.email,
        __fetchAvatars = _props.fetchAvatars,
        iconBackgroundColor = _props.iconBackgroundColor,
        iconColor = _props.iconColor,
        iconName = _props.iconName,
        imageShape = _props.imageShape,
        onClick = _props.onClick,
        objectType = _props.objectType,
        __portalId = _props.portalId,
        size = _props.size,
        __source = _props.source,
        src = _props.src,
        rest = _objectWithoutProperties(_props, ['className', 'defaultImage', 'domain', 'email', 'fetchAvatars', 'iconBackgroundColor', 'iconColor', 'iconName', 'imageShape', 'onClick', 'objectType', 'portalId', 'size', 'source', 'src']);

    var computedSrc = src || this.getDefaultImage({
      defaultImage: defaultImage,
      domain: domain,
      objectType: objectType
    });

    return _react2.default.createElement(
      _UIClickable2.default,
      {
        className: this.getClassName({ className: className, iconName: iconName, size: size }),
        onClick: onClick
      },
      this.renderImage(_extends({ imageShape: imageShape, size: size }, rest), { computedSrc: computedSrc }),
      this.renderIcon({ iconBackgroundColor: iconBackgroundColor, iconColor: iconColor, iconName: iconName, size: size })
    );
  }
});

exports.default = UIAvatar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/avatar/UIAvatar.js
// module id = 496
// module chunks = 2 3